import React from "react";
import { Tooltip } from "antd";
import { constants } from "../constant/constants";

function UserItemComponent({ record, callback }) {
  const deleteStaff = () => {
    callback(record, constants.STAFF.DELETE);
  };

  const editUser = () => {
    callback(record, constants.STAFF.EDIT);
  };
  
  return (
    <div className="w-full h-[72px] mb-[20px] px-[45px] py-[17px] flex flex-row no-wrap items-center bg-white rounded-[12px] opacity-100">
      {/* start image */}
      <div className="w-[8%] h-[38px] content-center">
        <img
          className="w-[28px] h-[28px]"
          src={"/images/user_blank_img.svg"}
          alt="User Image"
        />
      </div>
      {/* end image */}

      {/* start name */}
      <div className="w-[20%] h-[38px] content-center text-left font-ubold text-[16px] leading-[25px] tracking-[0.67px] text-[#111111] opacity-100 font-[Poppins]">
        {record.name}
      </div>
      {/* end name */}

      {/* start restaurant info */}
      <div className="w-[32%] h-auto content-center font-ubold text-left px-4 mr-6">
        <div className="text-[12px] leading-[20px] tracking-[0.5px] text-[#555555] opacity-90">
          <b>Restaurant Name:</b>{" "}
          <span className="font-uregular">{record.parentRestaurantInfo.name} </span>
          <br />
          <b>Branch Name:</b> <span className="font-uregular">{record.branchInfo.name}</span>
        </div>
      </div>
      {/* end restaurant info */}

      {/* start phone */}
      <div className="w-[20%] h-[38px] content-center text-left font-uregular text-[14px] leading-[25px] tracking-[0.67px] text-black opacity-100 font-[Poppins] px-2">
        +880{record.phone}
      </div>
      {/* end phone */}

      {/* start role */}
      <div className="w-[12%] h-[38px] content-center text-left font-uregular text-[16px] leading-[25px] tracking-[0.67px] text-[#FCBD10] opacity-100 font-[Poppins] px-2">
        {record.role}
      </div>
      {/* end role */}

      {/* start status  */}
      <div className="w-[10%] h-[38px] content-center text-left font-uregular text-[14px] leading-[25px] tracking-[0.67px] text-[#2EC114] opacity-100 font-[Poppins] px-2">
        {record.status}
      </div>
      {/* end status */}

      {/* start actions */}
      <div className="w-[10%] h-[36px] content-center flex flex-row no-wrap items-center justify-end">
        <Tooltip placement="bottom" title="Edit User">
          <img
            onClick={editUser}
            src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/edit_user_icon.svg"}
            alt="Edit User Icon"
            className="w-[36px] h-[36px] mr-[7px] cursor-pointer"
          />
        </Tooltip>

        <Tooltip placement="bottom" title="Delete User">
          <img
            onClick={deleteStaff}
            src={"/images/icons/remove.svg"}
            alt="Delete User Icon"
            className="w-[40px] h-[40px] cursor-pointer"
          />
        </Tooltip>
      </div>
      {/* end actions */}
    </div>
  );
}

export default UserItemComponent;
